module.exports = __webpack_public_path__ + "static/goose.3b555786.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/goose.jpg
// module id = 124
// module chunks = 35783957827783 270189111676482